var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonProvider } from '../../providers/common/common';
var SanitizerComponent = /** @class */ (function () {
    function SanitizerComponent(navCtrl, sanitizer, comProv) {
        this.navCtrl = navCtrl;
        this.sanitizer = sanitizer;
        this.comProv = comProv;
        this.sanitizer_id = 'sanitizer_' + String(Math.floor(Math.random() * 900 + 100));
        this.rss_ids = [];
        this.qr_values = [];
    }
    SanitizerComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var text = this.comProv.thumbnail(changes['text'].currentValue, 1080);
        text = this.setIframe(text);
        text = this.setQr(text);
        text = this.versionDiplay(text);
        this.disp_text = this.sanitizer.bypassSecurityTrustHtml(text);
        this.setRss(text);
        setTimeout(function () {
            _this.setClick();
            _this.moveQr();
        }, 1);
    };
    SanitizerComponent.prototype.setIframe = function (text) {
        var text_el = document.createElement('div');
        text_el.innerHTML = text;
        var iframe_els = text_el.getElementsByTagName('iframe');
        for (var i = 0; i < iframe_els.length; i++) {
            var iframe_src = iframe_els[i].src;
            iframe_els[i].src = this.comProv.replaceUrl(iframe_src, 2);
        }
        return text_el.innerHTML;
    };
    SanitizerComponent.prototype.setClick = function () {
        var sanitizer_el = document.getElementById(this.sanitizer_id);
        if (!sanitizer_el) {
            return;
        }
        var atag_el = sanitizer_el.getElementsByTagName('a');
        var that = this;
        var _loop_1 = function () {
            var href = atag_el[i].getAttribute('href');
            atag_el[i].onclick = function () {
                that.comProv.checkLink(href, that.navCtrl);
                return false;
            };
        };
        for (var i = 0; i < atag_el.length; i++) {
            _loop_1();
        }
    };
    SanitizerComponent.prototype.setRss = function (text) {
        var service_data = this.comProv.getService();
        if (!service_data['option']['is_rss_feed']) {
            return;
        }
        if (!text) {
            return;
        }
        var tmp_el = document.createElement('div');
        tmp_el.innerHTML = text;
        var parent_els = tmp_el.getElementsByClassName('parent_rss');
        if (!parent_els.length) {
            return;
        }
        for (var i = 0; i < parent_els.length; i++) {
            var parent_el = parent_els[i];
            var rss_id = parent_el.getAttribute('rss_id');
            if (rss_id) {
                this.rss_ids.push(rss_id);
            }
        }
    };
    SanitizerComponent.prototype.setQr = function (text) {
        if (!text) {
            return text;
        }
        var all_el = document.createElement('div');
        all_el.innerHTML = text;
        var display_qr_code_els = all_el.getElementsByClassName('display_qr_code');
        if (!display_qr_code_els.length) {
            return text;
        }
        for (var i = 0; i < display_qr_code_els.length; i++) {
            var display_qr_code_el = display_qr_code_els[i];
            var qr_value = '';
            if (display_qr_code_el.getAttribute('value')) {
                qr_value = display_qr_code_el.getAttribute('value');
            }
            this.qr_values.push(this.comProv.replaceUrl(qr_value, 1));
            // 移動用
            display_qr_code_el.innerHTML = '<div class="marker_qr"></div>';
            display_qr_code_el.classList.add('parent_qr_' + i);
        }
        return all_el.innerHTML;
    };
    SanitizerComponent.prototype.moveQr = function () {
        if (!this.qr_values.length) {
            return;
        }
        for (var i = 0; i < this.qr_values.length; i++) {
            var parent_qr_el = document.querySelector('.parent_qr_' + i);
            var marker_el = parent_qr_el.querySelector('.marker_qr');
            var place_qr_el = document.querySelector('.place_qr_' + i);
            if (parent_qr_el && marker_el && place_qr_el) {
                parent_qr_el.insertBefore(place_qr_el, marker_el);
            }
            if (marker_el) {
                marker_el.remove();
            }
        }
    };
    SanitizerComponent.prototype.versionDiplay = function (text) {
        var text_el = document.createElement('div');
        text_el.innerHTML = text;
        var parent_els = text_el.getElementsByClassName('app_version_diplay');
        if (!parent_els.length) {
            return text;
        }
        for (var i = 0; i < parent_els.length; i++) {
            var parent_el = parent_els[i];
            var equal = parent_el.getAttribute('equal');
            var disp_ver_ios = parent_el.getAttribute('ios');
            var disp_ver_and = parent_el.getAttribute('android');
            var check_version = this.checkVersion(equal, disp_ver_ios, disp_ver_and);
            if (!check_version) {
                parent_el.innerHTML = '';
            }
        }
        return text_el.innerHTML;
    };
    SanitizerComponent.prototype.checkVersion = function (equal, disp_ver_ios, disp_ver_and) {
        if (!this.comProv.isApp()) {
            return false;
        }
        var diplay_version;
        if (this.comProv.isAndroid()) {
            if (disp_ver_and.match(/^[0-9]+\.[0-9]+.[0-9]+$/)) {
                diplay_version = disp_ver_and;
            }
        }
        else if (this.comProv.isIos()) {
            if (disp_ver_ios.match(/^[0-9]+\.[0-9]+.[0-9]+$/)) {
                diplay_version = disp_ver_ios;
            }
        }
        if (!diplay_version) {
            return false;
        }
        if (!localStorage.getItem('app_version')) {
            return false;
        }
        var app_version = localStorage.getItem('app_version');
        app_version = app_version.replace(/ReleaseCount/g, '0');
        if (!app_version.match(/^[0-9]+\.[0-9]+.[0-9]+$/)) {
            return false;
        }
        var result = this.compareVersion(app_version, diplay_version);
        switch (equal) {
            case 'EQ': return result === 0;
            case 'GT': return result > 0;
            case 'LT': return result < 0;
            case 'GTE': return result >= 0;
            case 'LTE': return result <= 0;
            default:
                return false;
        }
    };
    SanitizerComponent.prototype.compareVersion = function (v1, v2) {
        var a = this.parseVersion(v1);
        var b = this.parseVersion(v2);
        if (a.major !== b.major)
            return a.major > b.major ? 1 : -1;
        if (a.minor !== b.minor)
            return a.minor > b.minor ? 1 : -1;
        if (a.patch !== b.patch)
            return a.patch > b.patch ? 1 : -1;
        return 0;
    };
    SanitizerComponent.prototype.parseVersion = function (v) {
        var _a = v.split('.').map(Number), major = _a[0], minor = _a[1], patch = _a[2];
        return { major: major, minor: minor, patch: patch };
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SanitizerComponent.prototype, "text", void 0);
    SanitizerComponent = __decorate([
        Component({
            selector: 'sanitizer',
            templateUrl: 'sanitizer.html'
        }),
        __metadata("design:paramtypes", [NavController,
            DomSanitizer,
            CommonProvider])
    ], SanitizerComponent);
    return SanitizerComponent;
}());
export { SanitizerComponent };
//# sourceMappingURL=sanitizer.js.map


// WEBPACK FOOTER //
// ./src/components/sanitizer/sanitizer.ts.pre-build-optimizer.js